import { useMutation } from '@tanstack/react-query';
import { sendView } from '../helpers/api/analyticsApi';
import { UserType, useUserType } from '../helpers/hooks';
import { useGuideStore } from '../stores/guideStore';
import { useFetchGuideById } from '../queries/guides';
import { GuideType } from '../types';
import { ActiveSplits, useReleaseToggle } from '../helpers/releaseToggle';

export const useSendView = () => {
  const { userType } = useUserType();
  const isPublic =
    userType === UserType.PUBLIC || userType === UserType.OPEN_ASSET_BANK;
  const activeGuideId = useGuideStore(s => s.activeGuideId);
  const activeChapterId = useGuideStore(s => s.activeChapterId);
  const activePageId = useGuideStore(s => s.activePageId);
  const { data: guide } = useFetchGuideById(activeGuideId);

  const chapter = guide?.chapters?.find(
    chapter => chapter.id === activeChapterId,
  );

  const page = chapter?.pages?.find(page => page.id === activePageId);

  const { data: isNewService } = useReleaseToggle(
    ActiveSplits.guidelinesQueryServiceRollout,
  );

  return useMutation((options: { name: string; guideType: GuideType }) => {
    return sendView(
      options?.name,
      guide?.id ?? '',
      guide?.title ?? '',
      chapter?.id ?? '',
      chapter?.title ?? '',
      page?.id ?? '',
      page?.title ?? '',
      isPublic,
      options.guideType,
      isNewService,
    );
  });
};
